//  All package and container imports.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl-next';
import '@atlaskit/css-reset';
import AppSpinner from './AppSpinner';
import { forwardRoute } from './actions/forward-route';
import routes from './routes';
import { FeatureFlagsProvider } from './utils/feature-flags-manager';

const i18nMappings = require('./i18n/en.json');

export default class AppRoot extends Component {
	// eslint-disable-next-line react/no-deprecated
	componentWillMount() {
		const { store, contentId, contentPlugin } = this.props;
		forwardRoute(contentId, contentPlugin)(store.dispatch);
	}

	render() {
		const { store, history } = this.props;
		const appReady = store.getState().ui.state.get('appReady');
		const accountId = store.getState().config.accountId;

		return (
			<Provider store={store}>
				<FeatureFlagsProvider accountId={accountId}>
					<IntlProvider locale="en" messages={i18nMappings}>
						<div className="ac-content">
							<ConnectedRouter history={history}>{routes}</ConnectedRouter>
							{appReady && <AppSpinner />}
						</div>
					</IntlProvider>
				</FeatureFlagsProvider>
			</Provider>
		);
	}
}

AppRoot.defaultProps = {
	contentId: null,
	contentPlugin: null,
};

AppRoot.propTypes = {
	contentId: PropTypes.string,
	contentPlugin: PropTypes.string,
	/*eslint react/forbid-prop-types: "off" */
	history: PropTypes.object.isRequired,
	store: PropTypes.object.isRequired,
};
